var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"skeleton",style:({width: _vm.width})},[_c('div',{staticClass:"lines"},[_c('div',{staticClass:"thumb pulse",style:({height: _vm.height})})])])])}
var staticRenderFns = []

export { render, staticRenderFns }